// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c58ae25d","455":"c4dce969","644":"edc79596"}[chunkId] + ".chunk.js";
};